export enum StepState {
    Idle = 'idle',
    Complete = 'complete',
    Running = 'running',
    Failed = 'failed',
    InvalidParameters = 'invalid-parameters',
    Waiting = 'waiting',
}
